import {
  VideoEventData,
  VideoEventName
} from '@components/assignments/task/blocks/slides/hooks/useVideoEventLogger';
import { XIcon } from '@icons';
import { MediaitemModel, MediaitemType } from '@models/mediaitems';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import MediaitemAudioPlayer from './MediaitemAudioPlayer';
import MediaitemImagePlayer from './MediaitemImagePlayer';
import MediaitemVideoPlayer from './MediaitemVideoPlayer';

const MediaitemPlayer = ({
  mediaitem,
  width,
  height,
  isClosable = true,
  onClose,
  onVideoEvent = () => {}
}: {
  mediaitem: MediaitemModel;
  isClosable?: boolean;
  onClose?: () => void;
  width: number;
  height: number;
  onVideoEvent?: (event: VideoEventName, data: VideoEventData) => void;
}) => {
  const router = useRouter();
  const { t } = router.query;
  const currentTimeSeconds = t ? Number(t) : undefined;

  if (!mediaitem) {
    return null;
  }

  return (
    <div className='w-full'>
      {mediaitem.type === MediaitemType.VIDEO && (
        <MediaitemVideoPlayer
          mediaitem={mediaitem}
          width={width}
          height={height}
          currentTimeSeconds={currentTimeSeconds}
          onVideoEvent={onVideoEvent}
        />
      )}
      {mediaitem.type === MediaitemType.AUDIO && <MediaitemAudioPlayer mediaitem={mediaitem} />}
      {mediaitem.type === MediaitemType.IMAGE && (
        <MediaitemImagePlayer mediaitem={mediaitem} showThumbnail={false} />
      )}
      {isClosable && onClose && (
        <XIcon
          size={24}
          className={classNames(
            setupForDark('text-primary shadow-md'),
            'absolute top-0 right-0 p-[10px] cursor-pointer z-10'
          )}
          onClick={onClose}
        />
      )}
    </div>
  );
};

export default MediaitemPlayer;
